var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column align-items-center"},[(_vm.order)?_c('PaymentStatusComponent',{attrs:{"order":_vm.order},on:{"done":_vm.payment_done}}):_vm._e(),_c('p',{staticStyle:{"margin-top":"128px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }